module.exports = __webpack_public_path__ + "media/Stimmfarben_und_Akzente.03a68bdf.mp3";